module.exports = __webpack_public_path__ + "img/9788925562957.9a0cc4b1.jpg";